/**
 * Shared design tokens for premium card styling across NextGen sections.
 * Extracted from the TaskCard (Skills) gold standard.
 */
export const CARD_TOKENS = {
  base: 'bg-white dark:bg-slate-900/50 rounded-2xl border border-gray-100 dark:border-white/5 shadow-none transition-all duration-500 overflow-hidden',
  hover: 'hover:shadow-2xl hover:shadow-[#F37022]/10 hover:border-[#F37022]/40',
  selected: 'shadow-xl shadow-[#F37022]/15 border-[#F37022]/60 bg-[#F37022]/5 dark:bg-[#F37022]/5',
  focus: 'focus-visible:ring-2 focus-visible:ring-[#F37022]/50 focus-visible:outline-none',
  shimmer: 'absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#F37022]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none',
  shimmerActive: 'opacity-100',
  titleHover: 'group-hover:text-[#F37022] transition-colors',
} as const;
